import { Navigate, Outlet } from 'react-router-dom';
import { DASHBOARD_PATH } from './constants';

const PublicRoute = ({ isAuthenticated }: RouterProps) =>
  isAuthenticated ? <Navigate to={'/' + DASHBOARD_PATH} /> : <Outlet />;

export default PublicRoute;
